import React, { Component } from 'react'

import { FilterParticipants } from 'containers/filters'
import { ParticipantsTable } from 'components/sections/participants'
import { apiConfiguration, apiParticipants } from 'helpers/decorators/api'
import { meta, permissions, tableCommon } from 'helpers/decorators'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import { connect } from 'react-redux'

import { participants as participantsApi } from '../../../redux/modules/api'
import InviteParticipantsModal from '../../../components/modals/participants/InviteParticipantsModal'
import modals from '../../../constants/modals'
import { modal } from '../../../redux/modules/app'
import { getLeaderId } from '../../../utils/token'
import { PropTypes } from 'prop-types'
import { Button } from '../../../components/misc'
import { get } from 'lodash'

@meta({
  title: 'Participants',
  intlKey: 'pageTitle.all_participants'
})
@permissions()
@tableCommon()
@apiConfiguration({
  getValues: [
    CONFIGURATION_KEYS.enableLabels.id,
    CONFIGURATION_KEYS.enableAwardLabels.id,
  ]
})
@apiParticipants({
  list: true,
  useCommonLimit: true
})
@connect(
    ({ auth }) => ({
      activeOrganization: auth.organization
    }),
    { setFilter: participantsApi.setParticipantsFilter, modal }
)
class ParticipantsAll extends Component {
  static propTypes = {
    modal: PropTypes.func.isRequired,
    permissions: PropTypes.object.isRequired
  }

  handleOpenModal = () => {
    this.props.modal(modals.INVITE_PARTICIPANTS_MODAL)
  }

  render() {
    const { user, activeOrganization } = this.props

    const alId = getLeaderId(user)

    return (
      <div>
        <FilterParticipants />
        <ParticipantsTable {...this.props} showLastActivity />

        <InviteParticipantsModal
          modalId={modals.INVITE_PARTICIPANTS_MODAL}
          modal={modal}
          orgId={get(activeOrganization,'id')}
          alId={alId}
        />
      </div>
    )
  }
}

export default ParticipantsAll
